var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "personalInfo-wrap",
    attrs: {
      "id": "personalInfo-wrap-id"
    }
  }, [_c('h2', [_vm._v("Personal Information")]), _c('p', [_vm._v("Enter and Update all your Personal Information here.")]), _c('div', {
    staticClass: "personalInfo-form"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.handleEnterKey.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-xxl-4 col-lg-6 col-md-6 mb-3"
  }, [_c('input-text', {
    attrs: {
      "rules": {
        required: true,
        digits: 10
      },
      "labelFor": "cell_phone",
      "labelName": "Cell Phone",
      "vmodel": _vm.personalInfo.cell_phone,
      "placeholder": "no dashes eg: 123456789)",
      "formGroupClass": "",
      "inputType": "text",
      "maxlength": "10",
      "inputmode": "numeric",
      "pattern": "\\d*"
    },
    on: {
      "update:vmodel": function updateVmodel($event) {
        return _vm.$set(_vm.personalInfo, "cell_phone", $event);
      }
    },
    nativeOn: {
      "input": function input($event) {
        return _vm.enforceDigitLimit.apply(null, arguments);
      },
      "keypress": function keypress($event) {
        return _vm.onlyAllowDigits.apply(null, arguments);
      }
    }
  }), _vm.showOtpSectionPhone ? _c('span', {
    staticClass: "validate-btn col-md-5 col-sm-6 d-flex rep-otp-validation"
  }, [_c('a', {
    staticClass: "validate-via-otp-link mt-2",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.openOtpModal('phone');
      }
    }
  }, [_vm._v(" TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR PHONE. ")])]) : _vm._e(), _vm.phoneMsg ? _c('div', {
    staticClass: "contacts-message-container form-group"
  }, [_c('div', {
    class: ['validate-message mt-2', _vm.phoneValidationMessage.type]
  }, [_c('div', {
    class: ['message-indicator', "".concat(_vm.phoneValidationMessage.type, "-indicator")]
  }), _c('span', {
    staticClass: "message-text"
  }, [_c('strong', {
    class: "".concat(_vm.phoneValidationMessage.type, "-text")
  }, [_vm._v(_vm._s(_vm.phoneValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.phoneValidationMessage.message) + " ")])])]) : _vm._e(), _vm.errors.cell_phone ? _c('div', {
    staticClass: "error-message"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.cell_phone))])]) : _vm._e()], 1), _c('div', {
    staticClass: "col-xxl-4 col-lg-6 col-md-6 mb-3"
  }, [_c('input-text', {
    attrs: {
      "rules": {
        required: true,
        email: true
      },
      "labelFor": "Email Address",
      "labelName": "Email Address",
      "placeholder": "Enter Email Address",
      "vmodel": _vm.personalInfo.email,
      "formGroupClass": ""
    },
    on: {
      "update:vmodel": function updateVmodel($event) {
        return _vm.$set(_vm.personalInfo, "email", $event);
      }
    }
  }), _vm.showOtpSectionEmail ? _c('span', {
    staticClass: "validate-btn col-md-5 col-sm-6 d-flex rep-otp-validation"
  }, [_c('a', {
    staticClass: "validate-via-otp-link mt-2",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.openOtpModal('email');
      }
    }
  }, [_vm._v(" TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL. ")])]) : _vm._e(), _vm.emailMsg ? _c('div', {
    staticClass: "contacts-message-container form-group"
  }, [_c('div', {
    class: ['validate-message mt-2', _vm.emailValidationMessage.type]
  }, [_c('div', {
    class: ['message-indicator', "".concat(_vm.emailValidationMessage.type, "-indicator")]
  }), _c('span', {
    staticClass: "message-text"
  }, [_c('strong', {
    class: "".concat(_vm.emailValidationMessage.type, "-text")
  }, [_vm._v(_vm._s(_vm.emailValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.emailValidationMessage.message) + " ")])])]) : _vm._e()], 1)]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.personalInfo.agent_code,
      expression: "personalInfo.agent_code"
    }],
    staticClass: "accountInfo-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Agent Code",
      "name": "agent_code",
      "disabled": ""
    },
    domProps: {
      "value": _vm.personalInfo.agent_code
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.personalInfo, "agent_code", $event.target.value);
      }
    }
  }), _vm.errors.agent_code ? _c('div', {
    staticClass: "error-message"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.agent_code))])]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_vm._m(1), _c('date-picker', {
    attrs: {
      "input-class": "accountInfo-field",
      "placeholder": "MM/DD/YYYY",
      "value-type": "format",
      "format": "MM/DD/YYYY"
    },
    model: {
      value: _vm.personalInfo.dob,
      callback: function callback($$v) {
        _vm.$set(_vm.personalInfo, "dob", $$v);
      },
      expression: "personalInfo.dob"
    }
  }), _vm.errors.dob && !_vm.personalInfo.dob ? _c('div', {
    staticClass: "error-message"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.dob))])]) : _vm._e()], 1), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.personalInfo.ssn,
      expression: "personalInfo.ssn"
    }],
    staticClass: "accountInfo-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter SSN Number",
      "name": "ssn"
    },
    domProps: {
      "value": _vm.personalInfo.ssn
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.personalInfo, "ssn", $event.target.value);
      }, _vm.handleInputChange]
    }
  }), _vm.errors.ssn ? _c('div', {
    staticClass: "error-message"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.ssn))])]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.personalInfo.first_name,
      expression: "personalInfo.first_name"
    }],
    staticClass: "accountInfo-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter First Name",
      "name": "first_name"
    },
    domProps: {
      "value": _vm.personalInfo.first_name
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.personalInfo, "first_name", $event.target.value);
      }, _vm.handleInputChange]
    }
  }), _vm.errors.first_name ? _c('div', {
    staticClass: "error-message"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.first_name))])]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Middle Name ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.personalInfo.middle_name,
      expression: "personalInfo.middle_name"
    }],
    staticClass: "accountInfo-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Middle Name",
      "name": "middle_name"
    },
    domProps: {
      "value": _vm.personalInfo.middle_name
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.personalInfo, "middle_name", $event.target.value);
      }, _vm.handleInputChange]
    }
  }), _vm.errors.middle_name ? _c('div', {
    staticClass: "error-message"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.middle_name))])]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_vm._m(4), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.personalInfo.last_name,
      expression: "personalInfo.last_name"
    }],
    staticClass: "accountInfo-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Last Name",
      "name": "last_name"
    },
    domProps: {
      "value": _vm.personalInfo.last_name
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.personalInfo, "last_name", $event.target.value);
      }, _vm.handleInputChange]
    }
  }), _vm.errors.last_name ? _c('div', {
    staticClass: "error-message"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.last_name))])]) : _vm._e()])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Telephone ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.personalInfo.telephone,
      expression: "personalInfo.telephone"
    }],
    staticClass: "accountInfo-field",
    attrs: {
      "type": "text",
      "placeholder": "eg: 1235688978 / no dashes",
      "name": "telephone"
    },
    domProps: {
      "value": _vm.personalInfo.telephone
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.personalInfo, "telephone", $event.target.value);
      }, _vm.handleInputChange]
    }
  }), _vm.errors.telephone ? _c('div', {
    staticClass: "error-message"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.telephone))])]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fax")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.personalInfo.fax,
      expression: "personalInfo.fax"
    }],
    staticClass: "accountInfo-field",
    attrs: {
      "type": "text",
      "placeholder": "eg: 1235688978 / no dashes",
      "name": "fax"
    },
    domProps: {
      "value": _vm.personalInfo.fax
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.personalInfo, "fax", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("800 Number ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.personalInfo.num_800,
      expression: "personalInfo.num_800"
    }],
    staticClass: "accountInfo-field",
    attrs: {
      "type": "text",
      "placeholder": "eg: 800688978 / no dashes",
      "name": "num_800"
    },
    domProps: {
      "value": _vm.personalInfo.num_800
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.personalInfo, "num_800", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-group row image-row"
  }, [_c('input-image', {
    ref: "image",
    attrs: {
      "rules": {
        required: false
      },
      "labelFor": "image",
      "labelName": "Personal Photo Image",
      "vmodel": _vm.agentImg,
      "formGroupClass": "col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-4 image-row",
      "imgSrc": _vm.imgSrc,
      "imgClass": "downline-upload-img ai-downline-img-preview",
      "imageSource": _vm.personalImageSource
    },
    on: {
      "deleteImage": function deleteImage($event) {
        _vm.deleteImage('personal', function () {
          return _vm.deleteImageRef('personal');
        });
      },
      "update:vmodel": function updateVmodel($event) {
        _vm.agentImg = $event;
      }
    }
  }), _c('input-image', {
    ref: "image",
    attrs: {
      "rules": {
        required: false
      },
      "labelFor": "image",
      "labelName": "Business Logo Image",
      "vmodel": _vm.businessLogo,
      "formGroupClass": "col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-4 image-row",
      "imgSrc": _vm.businessImage,
      "imgClass": "downline-upload-img",
      "imageSource": _vm.businessImageSource
    },
    on: {
      "deleteImage": function deleteImage($event) {
        _vm.deleteImage('business', function () {
          return _vm.deleteImageRef('business');
        });
      },
      "update:vmodel": function updateVmodel($event) {
        _vm.businessLogo = $event;
      }
    }
  })], 1), _c('div', {
    staticClass: "form-group row ai-location-wrapper"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Address Information "), _c('i', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.addAddress",
      modifiers: {
        "addAddress": true
      }
    }],
    staticClass: "fas fa-plus-circle"
  })]), _vm._l(_vm.addressInfo, function (address) {
    return _c('div', {
      key: address.id,
      staticClass: "col-md-6 col-sm-12 mb-3"
    }, [address.is_active ? _c('div', {
      staticClass: "location-div primary-location"
    }, [_c('p', [_vm._v(" " + _vm._s(address.address1) + ", " + _vm._s(address.address2) + " "), _c('i', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      class: address.usps_verified ? 'fas fa-check-circle' : 'fas fa-exclamation-triangle',
      attrs: {
        "title": address.usps_verified ? 'Validated with USPS' : 'Not validated with USPS'
      }
    }), _c('br'), _vm._v(_vm._s(address.city) + ", " + _vm._s(address.state) + ", " + _vm._s(address.zip) + " ")]), _c('button', {
      staticClass: "primaryAdrs-btn"
    }, [_vm._v("Primary")])]) : _c('div', {
      staticClass: "location-div set-as-primary"
    }, [_c('p', [_vm._v(" " + _vm._s(address.address1) + ", " + _vm._s(address.address2) + " "), _c('i', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      class: address.usps_verified ? 'fas fa-check-circle' : 'fas fa-exclamation-triangle',
      attrs: {
        "title": address.usps_verified ? 'Validated with USPS' : 'Not validated with USPS'
      }
    }), _c('br'), _vm._v(_vm._s(address.city) + ", " + _vm._s(address.state) + ", " + _vm._s(address.zip) + " ")]), _c('button', {
      staticClass: "primaryAdrs-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.updateAsPrimary(address.id);
        }
      }
    }, [_vm._v(" Set as Primary ")]), _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "ai-delete-a",
      attrs: {
        "type": "button",
        "title": "Delete"
      },
      on: {
        "click": function click($event) {
          return _vm.deleteAddress(address.id);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash"
    })])])]);
  })], 2), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-3 col-md-6"
  }, [_c('button', {
    staticClass: "univ-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.updatePersonalInfo();
      }
    }
  }, [_vm._v(" " + _vm._s(this.processing ? "Processing..." : "Update") + " ")])])])]), _c('AccountInfoOTP', {
    attrs: {
      "identifier": _vm.contactInfo,
      "identifierTypeText": _vm.otpType,
      "field": _vm.field
    },
    on: {
      "save": _vm.handleVerificationResult,
      "close": _vm.closeOtpModal
    },
    model: {
      value: _vm.showOtpModal,
      callback: function callback($$v) {
        _vm.showOtpModal = $$v;
      },
      expression: "showOtpModal"
    }
  })], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Agent Code "), _c('span', {
    staticClass: "required-indc"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("DOB "), _c('span', {
    staticClass: "required-indc"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("SSN "), _c('span', {
    staticClass: "required-indc"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("First Name "), _c('span', {
    staticClass: "required-indc"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Last Name "), _c('span', {
    staticClass: "required-indc"
  }, [_vm._v("*")])]);
}]

export { render, staticRenderFns }